
@if (loading()) {
  <div class="splash-screen">
    <app-full-screen-overflow
      [message]="'Loading...'">
    </app-full-screen-overflow>
  </div>
}

@if (underMaintenance()) {
  <app-maintenance></app-maintenance>
}

<router-outlet></router-outlet>
